/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import CompetitionQueryResult from './CompetitionQueryResult';

/**
 * The CompetitionOutputCmsCompetition model module.
 * @module model/CompetitionOutputCmsCompetition
 * @version 1.0
 */
class CompetitionOutputCmsCompetition {
    /**
     * Constructs a new <code>CompetitionOutputCmsCompetition</code>.
     * @alias module:model/CompetitionOutputCmsCompetition
     */
    constructor() { 
        
        CompetitionOutputCmsCompetition.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>CompetitionOutputCmsCompetition</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CompetitionOutputCmsCompetition} obj Optional instance to populate.
     * @return {module:model/CompetitionOutputCmsCompetition} The populated <code>CompetitionOutputCmsCompetition</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CompetitionOutputCmsCompetition();

            if (data.hasOwnProperty('competition')) {
                obj['competition'] = CompetitionQueryResult.constructFromObject(data['competition']);
            }
        }
        return obj;
    }


}

/**
 * @member {module:model/CompetitionQueryResult} competition
 */
CompetitionOutputCmsCompetition.prototype['competition'] = undefined;






export default CompetitionOutputCmsCompetition;

